<div class="flex-column gap">
    <app-card [title]="headerTitle()">
        <ng-template #content>
            <div class="flex gap">
                <app-date-input [form]="form" [prefix]="prefix" id="activeFrom"></app-date-input>
                <app-date-input [form]="form" [prefix]="prefix" id="activeTo"></app-date-input>
            </div>

            <div class="flex gap justify-content-end pt-4">
                @if (form.value.id) {
                    <app-cancel-button (clickEvent)="form.reset()"></app-cancel-button>
                }

                <app-save-button
                    [label]="(form.value.id ? 'common.update' : 'common.assign')" (clickEvent)="submit()"
                ></app-save-button>
            </div>
        </ng-template>
    </app-card>

    <app-card-table
        [gridData]="store.data.getCarePayments()"
        [refreshCallback]="store.api.getCarePayments"
        [refreshCallbackFragment]="carePaymentFrag"
        [additionalFilter]="additionalFilters()"
        [columns]="columns"
        [hideCheckboxes]="true"
        [tableTitle]="'folder.carePayment.assignedPayments'"
        [translatePrefix]="prefix"
        (detailCallback)="updateCarePayment($event)"
        (deleteCallbackWithEvent)="deleteCarePayment($event)"
    >
        <ng-template pTemplate="group" let-data="data">
            {{ data.name }}
        </ng-template>
    </app-card-table>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button label="common.close" (clickEvent)="dialogRef.close()"></app-cancel-button>
</div>
